import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Entiende',
    desc: 'Identificas tu síntoma dominante y los errores químicos que estás cometiendo.'
  }, {
    number: '02',
    title: 'Ajusta',
    desc: 'Implementas el Protocolo PFG y los hábitos de control de cortisol.'
  }, {
    number: '03',
    title: 'Mejora',
    desc: 'Sigues el plan de 21 días para desinflamar tu cuerpo y recuperar tu claridad mental.'
  }];
  return <section className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-143">
      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-144">
        <FadeIn data-id="element-145">
          <div className="text-center mb-16" data-id="element-146">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-147">
              Cómo funciona
            </h2>
            <p className="text-cream/70 text-lg max-w-2xl mx-auto" data-id="element-148">
              Un proceso simple de 3 pasos diseñado para tu cuerpo actual.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-149">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-sage/30 z-0" data-id="element-150"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-151">
              <div className="flex flex-col items-center text-center" data-id="element-152">
                <div className="w-24 h-24 rounded-full bg-sage flex items-center justify-center text-3xl font-bold text-forest mb-6 shadow-lg border-4 border-forest" data-id="element-153">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold text-gold mb-4" data-id="element-154">
                  {step.title}
                </h3>
                <p className="text-cream/80 text-lg leading-relaxed" data-id="element-155">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}